import { propertyMapping, required } from '@hakla/typed-forms'
import { AdminResetPasswordRequest } from '@/api/generated'
import { sameAs } from '@/shared/forms/validations/sameAs'

export interface ResetPasswordForm {
  newPassword: string
  passwordConfirmation: string
}

export function resetPasswordMapping() {
  return propertyMapping<AdminResetPasswordRequest, ResetPasswordForm>(({ generic }) => {
    return {
      newPassword: generic('newPassword').validations(required, sameAs('passwordConfirmation')),
      passwordConfirmation: generic('passwordConfirmation').validations(
        required,
        sameAs('newPassword')
      ),
    }
  })
}
